import { createBrowserHistory } from 'history';

// We use a shared browserHistory object so that all react2angualr components don't create their own instance.
// We also create this ourselves so that we can use it from within the angular code to trigger react route changes.
export const browserHistory = createBrowserHistory({ window });
